import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgIconSlack = (props) => /* @__PURE__ */ _jsx("svg", {
	viewBox: "0 0 123 123",
	...props,
	children: /* @__PURE__ */ _jsxs("g", {
		fillRule: "nonzero",
		fill: "none",
		children: [
			/* @__PURE__ */ _jsx("path", {
				d: "M79.3 8.1c-1.9-5.7-8-8.8-13.7-7-5.7 1.9-8.8 8-7 13.7l28.1 86.4c1.9 5.3 7.7 8.3 13.2 6.7 5.8-1.7 9.3-7.8 7.4-13.4 0-.2-28-86.4-28-86.4z",
				fill: "#ECB32D"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M35.8 22.2c-1.9-5.7-8-8.8-13.7-7-5.7 1.9-8.8 8-7 13.7l28.1 86.4c1.9 5.3 7.7 8.3 13.2 6.7 5.8-1.7 9.3-7.8 7.4-13.4 0-.2-28-86.4-28-86.4z",
				fill: "#63C1A0"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M114.7 79.6c5.7-1.9 8.8-8 7-13.7-1.9-5.7-8-8.8-13.7-7L21.5 87.1c-5.3 1.9-8.3 7.7-6.7 13.2 1.7 5.8 7.8 9.3 13.4 7.4.2 0 86.5-28.1 86.5-28.1z",
				fill: "#E01A59"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M39.5 104.1c5.6-1.8 12.9-4.2 20.7-6.7-1.8-5.6-4.2-12.9-6.7-20.7l-20.7 6.7 6.7 20.7z",
				fill: "#331433"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M83.1 89.9c7.8-2.5 15.1-4.9 20.7-6.7-1.8-5.6-4.2-12.9-6.7-20.7l-20.7 6.7 6.7 20.7z",
				fill: "#D62027"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M100.5 36.1c5.7-1.9 8.8-8 7-13.7-1.9-5.7-8-8.8-13.7-7L7.4 43.5C2.1 45.4-.9 51.2.7 56.7c1.7 5.8 7.8 9.3 13.4 7.4.2 0 86.4-28 86.4-28z",
				fill: "#89D3DF"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M25.4 60.5c5.6-1.8 12.9-4.2 20.7-6.7-2.5-7.8-4.9-15.1-6.7-20.7l-20.7 6.7 6.7 20.7z",
				fill: "#258B74"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M68.9 46.4c7.8-2.5 15.1-4.9 20.7-6.7-2.5-7.8-4.9-15.1-6.7-20.7l-20.7 6.7 6.7 20.7z",
				fill: "#819C3C"
			})
		]
	})
});
export default SvgIconSlack;
